import { Card, CardContent, CardHeader, Grid, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import { CanvasJSChart } from 'app/components/CanvasJs';
import { Dashboard, DashboardTab, GraficoArea } from 'app/main/visao-geral/components';
import { visaoGeralApi } from 'app/services/api/visaoGeralApi';
import { GlobalContext } from 'app/store/globalcontext';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { IoMdLock } from 'react-icons/io';
import { MdHelp } from 'react-icons/md';
import VisaoGeralLoading from './components/VisaoGeralLoading';
import { infoGraficosStyles } from './styles';

const HelperTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: 200,
    fontSize: theme.typography.pxToRem(12),
  },
}))(Tooltip);

const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

const getNomeBanco = (banco) => {
  if (banco) {
    return `${banco} -`;
  }

  return '';
};

const TIPO_CONTA = {
  CONTA_CORRENTE: 'Corrente',
  CONTA_POUPANCA: 'Poupança',
  CONTA_INVESTIMENTO: 'Investimento',
  CONTA_CAIXINHA: 'Caixinha',
};

const montarDetalhesContas = (detalhes) => {
  return (
    <>
      {detalhes?.map((conta, index) => {
        return (
          <div key={`detalhes-contas-${index}`}>
            {`${conta.nome} - ${getNomeBanco(conta.banco)} ${TIPO_CONTA[conta.tipoConta]} - ${getCurrency(
              conta.saldo
            )}`}
            <br />
          </div>
        );
      })}
    </>
  );
};

const grafico = {
  azul: '#255c9d',
  amarelo: '#F9CF00',
  laranja: '#EB891A',
  laranjaEscuro: '#E46713',
  vermelho: '#DA251C',
  bonina: '#97292C',
  azulClaro: '#C4EDF5',
  azulProfundo: '#5FDBF1',
  azulEscuro: '#2C99AC',
  cinzaClaro: '#787E88 ',
  cinzaEscuro: '#3E444D',
  cinzaClaroDespesa: '#666d78',
  azulReceita: '#36b5cb',
  azulEscuroReceita: '#3da4bc',
  cinzaDespesa: '#666d78',
  azulSaldo: '#171b54',
  cinzaSaldo: '#3e444d',
};

const colors = [
  grafico.azulClaro,
  grafico.azulProfundo,
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? grafico.azulEscuro : grafico.azulEscuroReceita,
  grafico.cinzaClaro,
  grafico.cinzaEscuro,
];
const legendText = ['Até 7 dias', 'De 7 a 30 dias', 'De 30 a 60 dias', 'De 60 a 90 dias', 'Acima de 90 dias'];

const Graficos = () => {
  const [dashboardSaldo, setDashboardSaldo] = useState();
  const [detalhesSaldo, setDetalhesSaldo] = useState('');
  const [periodoContasPagar, setPeriodoContasPagar] = useState('0');
  const [periodoContasReceber, setPeriodoContasReceber] = useState('0');

  const [dashboardContasPagar, setDashboardContasPagar] = useState(0);
  const [dashboardContasReceber, setDashboardContasReceber] = useState(0);
  const [dashboardInadimplencia, setDashboardInadimplencia] = useState(0);

  const [dadosGraficoFluxoCaixa, setDadosGraficoFluxoCaixa] = useState([]);
  const [loadingGraficoFluxoCaixa, setLoadingGraficoFluxoCaixa] = useState(false);

  const [graficoInadimplencia, setGraficoInadimplencia] = useState(null);
  const [loadingGraficoInadimplencia, setLoadingGraficoInadimplencia] = useState(false);

  const [categoriasReceitaDespesa, setCategoriasReceitaDespesa] = useState([]);
  const [descricaoCategoriasReceitaDespesa, setDescricaoCategoriasReceitaDespesa] = useState([]);
  const [dadosGraficoReceitaDespesa, setDadosGraficoReceitaDespesa] = useState();
  const [loadingGraficoReceitaDespesa, setLoadingGraficoReceitaDespesa] = useState(false);

  const [dadosDashboardVendas, setDadosDashboardVendas] = useState([]);
  const [categoriasDashboardVendas, setCategoriasDashboardVendas] = useState([]);
  const [totalVendas, setTotalVendas] = useState();
  const [evolucaoPositiva, setEvolucaoPositiva] = useState(false);
  const [evolucaoVendas, setEvolucaoVendas] = useState(13);

  const [visualizarDados] = useContext(GlobalContext).visualizarDadosDashboard;

  const abasDashboardVendas = ['Semana', 'Mês', 'Ano'];

  const classes = infoGraficosStyles();

  const buscarDadosDashboardVendas = async () => {
    const response = await visaoGeralApi.buscarDadosDashboardVendas();

    setTotalVendas(response.data?.totalVendas);
    setEvolucaoPositiva(response.data?.evolucaoPositiva);
    setEvolucaoVendas(response.data?.evolucao);
  };

  const buscarDadosGraficoVendas = async (abaSelecionada) => {
    let dadosGraficoVenda;
    if (abaSelecionada === 0) {
      const response = await visaoGeralApi.buscarDadosGraficoVendas({ periodo: 'SEMANAL' });

      dadosGraficoVenda = response.data;
    } else if (abaSelecionada === 1) {
      const response = await visaoGeralApi.buscarDadosGraficoVendas({ periodo: 'MENSAL' });

      dadosGraficoVenda = response.data;
    } else if (abaSelecionada === 2) {
      const response = await visaoGeralApi.buscarDadosGraficoVendas({ periodo: 'ANUAL' });

      dadosGraficoVenda = response.data;
    }

    const categorias = [];
    const dados = [];

    dadosGraficoVenda.forEach((dado) => {
      categorias.push(dado.periodo);
      dados.push(dado.valor);
    });

    setCategoriasDashboardVendas(categorias);
    setDadosDashboardVendas(dados);
  };

  const buscarSaldoContas = async () => {
    const response = await visaoGeralApi.buscarSaldoContas();
    const saldoContas = response.data;

    setDashboardSaldo(saldoContas);

    const detalhes = montarDetalhesContas(saldoContas?.detalhes);
    setDetalhesSaldo(detalhes);
  };

  const BoxGrafico = ({ title, loading, helper, children, columns = 6, classe }) => (
    <Grid item xs={12} sm={12} md={columns} lg={columns} xl={columns} className={classe}>
      <Card>
        <Grid item container alignItems="center" justify="flex-start">
          <CardHeader title={title} />
          {helper && (
            <HelperTooltip title={helper} placement="right">
              <div>
                <MdHelp size={20} />
              </div>
            </HelperTooltip>
          )}
        </Grid>
        <CardContent style={{ minHeight: '440px' }}>
          {loading ? <VisaoGeralLoading size={50} style={{ minHeight: '400px' }} /> : children}
        </CardContent>
      </Card>
    </Grid>
  );

  const buscarDadosDashboardContasPagar = async (periodo) => {
    const params = {
      periodo,
    };

    const retorno = await visaoGeralApi.buscaContasPagar(params);

    setDashboardContasPagar(retorno.data);
  };

  const buscarDadosDashboardContasReceber = async () => {
    const params = {
      periodo: periodoContasReceber,
    };

    const retorno = await visaoGeralApi.buscaContasReceber(params);

    setDashboardContasReceber(retorno.data);
  };

  const buscarDadosDashboardInadimplencia = async () => {
    const params = {
      periodo: -1,
    };

    const retorno = await visaoGeralApi.buscaContasReceber(params);

    setDashboardInadimplencia(retorno.data);
  };

  const buscarDadosGraficoInadimplencia = async () => {
    setLoadingGraficoInadimplencia(true);

    const retorno = await visaoGeralApi.buscarInadimplencia();
    let somaTotal = 0;

    retorno.data.forEach((value) => {
      somaTotal += value.saldoTotal;
    });

    retorno.data.forEach((value, key) => {
      value.color = colors[key];
      value.legendText = legendText[key];
      value.percentage = ((value.saldoTotal / somaTotal) * 100).toFixed(2);
      value.showInLegend = true;
      value.y = value.saldoTotal;

      delete value.saldoTotal;
    });

    setGraficoInadimplencia(retorno.data);

    setLoadingGraficoInadimplencia(false);
  };

  const buscarDadosReceitasDespesas = async () => {
    setLoadingGraficoReceitaDespesa(true);

    const response = await visaoGeralApi.buscarReceitasDespesas();

    const categorias = [];
    const descricaoCategorias = [];
    const dadosReceita = {
      name: 'Receitas',
      data: [],
    };
    const dadosDespesa = {
      name: 'Despesas',
      data: [],
    };

    response.data.forEach((registro) => {
      const mes = moment(registro.competencia)
        .locale('pt-br')
        .format('MMM');

      const competencia = moment(registro.competencia)
        .locale('pt-br')
        .format('MMMM/YYYY');

      categorias.push(mes);
      descricaoCategorias.push(competencia);
      dadosReceita.data.push(registro.totalReceitas);
      dadosDespesa.data.push(registro.totalDespesas);
    });

    setCategoriasReceitaDespesa(categorias);
    setDescricaoCategoriasReceitaDespesa(descricaoCategorias);
    setDadosGraficoReceitaDespesa([dadosReceita, dadosDespesa]);

    setLoadingGraficoReceitaDespesa(false);
  };

  const buscarDadosGraficoFluxoCaixa = async () => {
    setLoadingGraficoFluxoCaixa(true);

    const receitas = {
      nome: 'Receitas',
      dados: [],
    };

    const despesas = {
      nome: 'Despesas',
      dados: [],
    };

    const saldos = {
      nome: 'Saldos',
      dados: [],
    };

    try {
      const response = await visaoGeralApi.buscarFluxoCaixa();

      response.data.receitas.forEach((registro) => {
        const obj = {};
        const data = registro.data.split('-');

        obj.x = new Date(data[0], data[1] - 1, data[2]);
        obj.y = registro.valor;

        receitas.dados.push(obj);
      });

      response.data.despesas.forEach((registro) => {
        const obj = {};
        const data = registro.data.split('-');

        obj.x = new Date(data[0], data[1] - 1, data[2]);
        obj.y = registro.valor;

        despesas.dados.push(obj);
      });

      response.data.saldos.forEach((registro) => {
        const obj = {};
        const data = registro.data.split('-');

        obj.x = new Date(data[0], data[1] - 1, data[2]);
        obj.y = registro.valor;

        saldos.dados.push(obj);
      });

      setDadosGraficoFluxoCaixa([receitas, despesas, saldos]);
    } catch (e) {
      for (let i = 0; i <= 6; i++) {
        const obj = {};

        const date = moment()
          .add(i + 1, 'days')
          .format('YYYY-MM-DD');

        obj.x = new Date(date);
        obj.y = 0;

        receitas.dados.push(obj);
        despesas.dados.push(obj);
        saldos.dados.push(obj);
      }

      setDadosGraficoFluxoCaixa([receitas, despesas, saldos]);
      setLoadingGraficoFluxoCaixa(false);
    } finally {
      setLoadingGraficoFluxoCaixa(false);
    }
  };

  useEffect(() => {
    buscarDadosGraficoFluxoCaixa();
    buscarDadosGraficoInadimplencia();
    buscarDadosReceitasDespesas();
    buscarDadosDashboardVendas();
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <Dashboard
            titulo="Saldo"
            className={'stepSaldo'}
            valor={dashboardSaldo?.saldoTotal}
            descricao="Saldo total"
            periodoFixo="Hoje"
            detalhes={detalhesSaldo}
            buscarDadosDashboard={buscarSaldoContas}
            visualizarDados={visualizarDados}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <Dashboard
            titulo="Contas a pagar"
            className={'stepContasPagar'}
            valor={dashboardContasPagar?.saldoTotal}
            descricao="Títulos em aberto"
            periodo={periodoContasPagar}
            setPeriodo={setPeriodoContasPagar}
            buscarDadosDashboard={buscarDadosDashboardContasPagar}
            visualizarDados={visualizarDados}
            opcoesFiltro={[
              { valor: '0', descricao: 'Hoje' },
              { valor: '-1', descricao: 'Atrasadas' },
              { valor: '7', descricao: 'Próximos 7 dias' },
              { valor: '15', descricao: 'Próximos 15 dias' },
              { valor: '30', descricao: 'Próximos 30 dias' },
            ]}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <Dashboard
            titulo="Contas a receber"
            className={'stepContasReceber'}
            valor={dashboardContasReceber?.saldoTotal}
            descricao="Títulos em aberto"
            periodo={periodoContasReceber}
            setPeriodo={setPeriodoContasReceber}
            buscarDadosDashboard={buscarDadosDashboardContasReceber}
            visualizarDados={visualizarDados}
            opcoesFiltro={[
              { valor: '0', descricao: 'Hoje' },
              { valor: '-1', descricao: 'Vencidas' },
              { valor: '7', descricao: 'Próximos 7 dias' },
              { valor: '15', descricao: 'Próximos 15 dias' },
              { valor: '30', descricao: 'Próximos 30 dias' },
            ]}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <Dashboard
            titulo="Inadimplência"
            className={'stepInadimplencia'}
            valor={dashboardInadimplencia?.saldoTotal}
            descricao="Títulos atrasados"
            periodoFixo="Hoje"
            buscarDadosDashboard={buscarDadosDashboardInadimplencia}
            visualizarDados={visualizarDados}
          />
        </Grid>

        {!visualizarDados ? (
          <Grid container spacing={3} style={{ position: 'relative', height: '100vh' }}>
            <div className={classes.semAcesso}>
              <div className={classes.semAcessoIcon}>
                <IoMdLock fontSize={50} />
              </div>

              <p className={classes.textInfo} style={{ textAlign: 'center' }}>
                Você não tem permissão
                <br /> para visualizar as informações
              </p>
            </div>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <img
                src={'assets/images/dashboardBlur/fluxoCaixaBlur.png'}
                alt="Prévia do gráfico de fluxo de caixa"
                style={{ borderRadius: 5, height: '528px' }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <img
                src={'assets/images/dashboardBlur/inadimplenciaBlur.png'}
                alt="Prévia do gráfico de inadimplência"
                style={{ borderRadius: 5, height: '528px' }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <img
                src={'assets/images/dashboardBlur/receitasXdespesasBlur.png'}
                alt="Prévia do gráfico de receitas x despesas"
                style={{ borderRadius: 5, height: '544px' }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <img
                src={'assets/images/dashboardBlur/vendasBlur.png'}
                alt="Prévia do gráfico de vendas"
                style={{ borderRadius: 5, height: '544px' }}
              />
            </Grid>
          </Grid>
        ) : (
          <>
            <BoxGrafico
              title="Previsão de fluxo de caixa"
              classe={'stepFluxoDeCaixa'}
              loading={loadingGraficoFluxoCaixa}
              helper="O gráfico representa somente valores de contas a pagar e receber em aberto no sistema a partir da data atual."
            >
              <CanvasJSChart
                options={{
                  culture: 'pt-br',
                  animationEnabled: true,

                  axisX: {
                    valueFormatString: 'DD/MM/YYYY',
                    labelFontSize: 11,
                  },
                  axisY: {
                    prefix: 'R$',
                    labelFontSize: 11,
                  },
                  toolTip: {
                    shared: true,
                  },
                  legend: {
                    fontSize: 11,
                    cursor: 'pointer',
                    verticalAlign: 'bottom',
                  },
                  data: [
                    {
                      type: 'column',
                      name: 'Receita',
                      showInLegend: true,
                      xValueFormatString: 'DD/MM/YYYY',
                      yValueFormatString: 'R$###,###.00',
                      color:
                        process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front'
                          ? grafico.azulReceita
                          : grafico.azulEscuroReceita,
                      dataPoints: dadosGraficoFluxoCaixa[0]?.dados,
                    },
                    {
                      type: 'column',
                      name: 'Despesa',
                      showInLegend: true,
                      xValueFormatString: 'DD/MM/YYYY',
                      yValueFormatString: 'R$###,###.00',
                      color:
                        process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front'
                          ? grafico.cinzaDespesa
                          : grafico.cinzaClaroDespesa,
                      dataPoints: dadosGraficoFluxoCaixa[1]?.dados,
                    },
                    {
                      type: 'line',
                      name: 'Saldo final',
                      showInLegend: true,
                      color:
                        process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front'
                          ? grafico.azulSaldo
                          : grafico.cinzaSaldo,
                      yValueFormatString: 'R$###,###.00',
                      dataPoints: dadosGraficoFluxoCaixa[2]?.dados,
                    },
                  ],
                }}
              />
            </BoxGrafico>

            <BoxGrafico title="Inadimplência" loading={loadingGraficoInadimplencia} classe={'stepGraficoInadimplencia'}>
              {graficoInadimplencia &&
              graficoInadimplencia.every((saldo) => {
                return saldo.y === 0;
              }) ? (
                <div className={classes.infoCard}>
                  <InfoIcon className={classes.iconInfo} />
                  <p className={classes.textInfo}>Ainda não temos informações de inadimplência para exibir.</p>
                </div>
              ) : (
                <CanvasJSChart
                  options={{
                    theme: 'light2',
                    culture: 'pt-br',
                    animationEnabled: false,
                    data: [
                      {
                        title: {
                          text: 'teste',
                        },
                        type: 'funnel',
                        toolTipContent: `<b>{legendText}</b>: R\${y} <b>({percentage}%)</b>`,
                        neckWidth: 20,
                        neckHeight: 0,
                        valueRepresents: 'area',
                        explodeOnClick: false,
                        dataPoints: graficoInadimplencia,
                      },
                    ],
                  }}
                />
              )}
            </BoxGrafico>

            <BoxGrafico
              title="Receitas X Despesas"
              loading={loadingGraficoReceitaDespesa}
              columns={8}
              classe={'stepReceitasXDespesas'}
            >
              <GraficoArea
                categorias={categoriasReceitaDespesa}
                descricaoCategorias={descricaoCategoriasReceitaDespesa}
                conteudo={dadosGraficoReceitaDespesa}
                height="400px"
              />
            </BoxGrafico>

            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <DashboardTab
                titulo="Vendas"
                className={'stepGraficoVendas'}
                subtitulo="Vendas no mês atual"
                totalVendas={totalVendas}
                abas={abasDashboardVendas}
                buscarDadosGrafico={buscarDadosGraficoVendas}
                trendingUp={evolucaoPositiva}
                evolucaoVendas={evolucaoVendas}
                categorias={categoriasDashboardVendas}
                dadosGrafico={dadosDashboardVendas}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default Graficos;
